import React from 'react';
import { useNavigate, useNavigationType } from 'react-router-dom';

export const useSafeNavigate = () => {
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const handleRouteBack = React.useCallback(() => {
    if (navigationType === 'POP') {
      navigate('/dashboard');
    } else {
      navigate(-1);
    }
  }, [navigate, navigationType]);

  return { handleRouteBack, navigate };
};
